<template>
  <v-container class="custom-container responsive-height">
    <v-row dense>
      <v-col lg="12" md="12" sm="12" cols="12">
        <v-sheet
          class="transactionTable pb-3"
          elevation="0"
          :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
        >
          <div class="title-bar">
            <div>
              <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
              <span class="ml-2">Leverage</span>
            </div>
          </div>
          <v-data-table
            :headers="headers"
            :items="userleverages"
            :items-per-page="5"
            class="elevation-0"
          >
            <template v-slot:item.sl="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:item.trading_account_no="{ item }">
              {{
                `${item.trading_account_no} (${item.tradingaccounttypes.account_type_display})`
              }}
            </template>
            <template v-slot:item.leverage="{ item }">
              {{ `1:${item.leverage}` }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>

    <v-card
      class="rounded-0 deposit-form transactionTable mt-3 pt-5 pb-10 px-2"
      :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
    >
      <div class="title-bar pl-0 pb-8 text-capitalize">
        <div>
          <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
          <span class="ml-2"
            >Change your trading account leverage from here</span
          >
        </div>
      </div>

      <v-row >
        <v-col cols="12" sm="12" md="8" lg="7">
          <fieldset>
            <legend>MT5 Account</legend>
            <v-select
              append-icon="mdi-chevron-down"
              v-model="selectedAccount"
              :items="userleverages"
              :item-text="
                (item) =>
                  `${item.trading_account_no} (${item.tradingaccounttypes.account_type_display})`
              "
              item-value="trading_account_no"
              label="Select"
              :readonly="!isEditable"
              class="custom-select mb-2"
              hide-details
              single-line
              solo
            >
            </v-select>
          </fieldset>
        </v-col>

        <v-col cols="12" sm="12" md="8" lg="7">
          <fieldset>
            <legend>Current Leverage</legend>
            <v-text-field
              v-model="currentLeverage"
              readonly
              class="custom-select mb-2"
              hide-details
              placeholder="1:50"
              single-line
              solo
            >
            </v-text-field>
          </fieldset>
        </v-col>

        <v-col cols="12" sm="12" md="8" lg="7">
          <fieldset>
            <legend>New Leverage</legend>
            <v-select
              v-model="newLeverage"
              :items="sortedLeverages"
              label="Select"
              class="custom-select mb-2"
              hide-details
              single-line
              solo
              append-icon="mdi-chevron-down"
            >
            </v-select>
          </fieldset>
        </v-col>
      </v-row>

      <v-btn
        color="greenMain"
        large
        tile
        elevation="0"
        class="ma-0 mt-6 text-capitalize btn-account"
        @click="saveLeverage"
        :loading="loading" :disabled="loading"
      >
        Save Change
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { LEVERAGE__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    headers: [
      { text: "SL.", value: "sl" },
      { text: "MT5 Account No.", value: "trading_account_no" },
      { text: "Leverage", value: "leverage" },
    ],
    selectedAccount: "",
    currentLeverage: "",
    newLeverage: "",
    isEditable: true,
    sortedLeverages: [],
    loading: false,
  }),
  computed: {
    ...mapState("leverage", ["userleverages", "allleverages"]),
  },
  watch: {
    selectedAccount(newAccount) {
      const account = this.userleverages.find(
        (item) => item.trading_account_no === newAccount
      );
      if (account) {
        this.currentLeverage = `1:${account.leverage}`;
      } else {
        this.currentLeverage = "";
      }
    },
    allleverages: {
      immediate: true,
      handler(newAllLeverages) {
        this.updateSortedLeverages(newAllLeverages);
      },
    },
  },
  methods: {
    ...mapActions("leverage", [
      LEVERAGE__ACTIONS.ALLLEVERAGES,
      LEVERAGE__ACTIONS.USERLEVERAGE,
      LEVERAGE__ACTIONS.UPDATELEVERAGE,
    ]),
    async saveLeverage() {
      this.loading = true;
      try{
        const data = {
        trading_account_no: this.selectedAccount,
        new_leverage: parseInt(this.newLeverage.split(":")[1]),
        currentLeverage: parseInt(this.currentLeverage.split(":")[1]),
      };
      await this[LEVERAGE__ACTIONS.UPDATELEVERAGE](data);
      this.selectedAccount =  this.$route.query.account;
      this.newLeverage = "";
      this.currentLeverage = "";
      }catch(error){
        toast.error(error.message || 'Failed to process withdrawal');
      }finally{
        this.loading = false;
      }
      
    },
    updateSortedLeverages(leverages) {
      this.sortedLeverages = leverages
        .slice()
        .sort((a, b) => a.leverage - b.leverage)
        .map((l) => `1:${l.leverage}`);
    },
  },
  async mounted() {
    const account = this.$route.query.account;

    await this[LEVERAGE__ACTIONS.ALLLEVERAGES]();
    await this[LEVERAGE__ACTIONS.USERLEVERAGE]();

    if (account) {
      this.selectedAccount = account;
      this.isEditable = false;
    }
  },
};
</script>